import { render, staticRenderFns } from "./Asset.vue?vue&type=template&id=ae7e4776&scoped=true&"
import script from "./Asset.vue?vue&type=script&lang=ts&"
export * from "./Asset.vue?vue&type=script&lang=ts&"
import style0 from "./Asset.vue?vue&type=style&index=0&id=ae7e4776&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7e4776",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
installComponents(component, {VBreadcrumbs})
